var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedicalSignAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 2C9.94771 2 9.5 2.44772 9.5 3V5.96452L7.40383 3.86835C7.01331 3.47783 6.38015 3.47783 5.98962 3.86835L3.8683 5.98967C3.47778 6.38019 3.47778 7.01336 3.8683 7.40388L5.96442 9.5H3C2.44772 9.5 2 9.94771 2 10.5V13.5C2 14.0523 2.44772 14.5 3 14.5H5.96452L3.86829 16.5962C3.47776 16.9868 3.47776 17.6199 3.86829 18.0104L5.98961 20.1318C6.38013 20.5223 7.0133 20.5223 7.40382 20.1318L9.5 18.0356V21C9.5 21.5523 9.94771 22 10.5 22H13.5C14.0523 22 14.5 21.5523 14.5 21V18.0356L16.5962 20.1318C16.9867 20.5223 17.6199 20.5223 18.0104 20.1318L20.1318 18.0105C20.5223 17.62 20.5223 16.9868 20.1318 16.5963L18.0355 14.5H21C21.5523 14.5 22 14.0523 22 13.5V10.5C22 9.94771 21.5523 9.5 21 9.5H18.0356L20.1317 7.40384C20.5223 7.01331 20.5223 6.38015 20.1317 5.98962L18.0104 3.8683C17.6199 3.47778 16.9867 3.47778 16.5962 3.8683L14.5 5.96451V3C14.5 2.44772 14.0523 2 13.5 2H10.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicalSignAlt);
export default __webpack_public_path__ + "static/media/medical-sign-alt.b165119263c071b3f4549d63e497c932.svg";
export { ForwardRef as ReactComponent };